module.exports = __webpack_public_path__ + "img/favicon-1.aca30df7.png";